"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CarbonTx = __importStar(require("../../../util/tx"));
const long_1 = __importDefault(require("long"));
const utils_1 = require("../utils");
const TxTypes = {
    Transfer: "cosmos-sdk/MsgTransfer",
};
const MsgTransfer = {
    aminoType: TxTypes.Transfer,
    valueMap: {
        timeoutHeight: {
            revisionHeight: utils_1.ConvertEncType.Long,
            revisionNumber: utils_1.ConvertEncType.Long,
        },
        timeoutTimestamp: utils_1.ConvertEncType.Long,
    },
};
const pruneTransferProcess = {
    toAminoProcess: (amino, input) => {
        var _a, _b, _c;
        const newInput = input;
        if (long_1.default.isLong(input.timeoutTimestamp) && new long_1.default(0).eq(input.timeoutTimestamp)) {
            delete newInput.timeoutTimestamp;
        }
        if (long_1.default.isLong((_a = input.timeoutHeight) === null || _a === void 0 ? void 0 : _a.revisionNumber) && new long_1.default(0).eq((_b = input.timeoutHeight) === null || _b === void 0 ? void 0 : _b.revisionNumber)) {
            (_c = newInput.timeoutHeight) === null || _c === void 0 ? true : delete _c.revisionNumber;
        }
        return { amino, input: newInput };
    },
    fromAminoProcess: (amino, input) => {
        const newInput = input;
        return { amino, input: newInput };
    },
};
const IbcAmino = {
    [CarbonTx.Types.MsgTransfer]: utils_1.generateAminoType(MsgTransfer, pruneTransferProcess),
};
exports.default = IbcAmino;
